import React, { useEffect, useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import Image from "../components/elements/Image";
import Logo from '../assets/images/Memory_Doodle.svg';
import Button from "../components/forms/Button";
import { classNames } from "../helpers/classNames";

const DefaultHeader = () => {
  const [scrolled, setScrolled] = useState(false);

  const menu = [
    {
      _id: 1,
      name: "Home",
      link: "/",
    },
    {
      _id: 2,
      name: "How It Works",
      link: "/how-it-works",
    },
    {
      _id: 3,
      name: "Pricing",
      link: "/pricing",
    }
  ]

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setScrolled(isScrolled);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <header className={classNames("fixed z-10 top-0 left-0 w-full flex items-center transition-all duration-300", scrolled ? "h-24 bg-white shadow" :"h-40")}>
        <div className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-9xl mx-auto">
          <div className="flex items-center gap-40">
            <div className={classNames("w-48 transition-all duration-300", scrolled ? "h-12" :"h-14")}>
              <Link to={"/"} className="block w-full h-full">
                <Image src={Logo} alt={'Logo'} width={'100%'} height={'100%'} effect={'blur'} classes={'object-contain object-left'} />
              </Link>
            </div>
            <div className="flex items-center gap-6 mr-auto">
              {menu?.map((item) => (
                <div className="relative" key={item._id}>
                  <NavLink
                    to={item.link}
                    className={({ isActive }) => "px-3 text-lg uppercase font-medium font-Fredoka hover:text-blue transition-all duration-200 " + (isActive ? "text-blue" : "text-black")}
                  >{item.name}</NavLink>
                </div>
              ))}
            </div>
            <div className="relative">
              <Button
                buttonHasLink={true}
                buttonLink={"/signin"}
                buttonLabel={"Signin"}
                buttonLabelClasses={"text-xl uppercase"}
                buttonClasses={"hover:scale-105 bg-gradient-to-tr from-red to-yellow h-14 !px-12"}
              />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default DefaultHeader;